import { ApiClient } from "../ApiClient";

/**
 * This function will be used during account activation to get the account using the generated token
 * returns: Promise<Response>
 */
export const createIdentityVerificationSession = async (url) => {
  // ApiClient.post handles baseUrl, CSRF token, and headers automatically.
  // 'url' here is the dynamic endpoint passed from the component.
  return ApiClient.post(url);
};

/**
 * Check the current verification status from Stripe
 * Used for long polling fallback when webhooks are delayed
 * returns: Promise<Response>
 */
export const checkVerificationStatus = async (url, sessionId) => {
  // ApiClient.get handles baseUrl and Content-Type: application/json.
  // We concatenate the url and sessionId as per the original logic.
  return ApiClient.get(`${url}/${sessionId}`);
};
